/* Modulo: Shop the Look — hotspot dots synced to a stacked product card.
   All product data is server-rendered into slides; JS only toggles the
   active index across dots / slides / thumbnails / arrows / counter.
   Vanilla IIFE. Theme-editor aware. No deps. */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  function pad2(n) { return (n < 10 ? '0' : '') + n; }

  function initSection(el) {
    if (!el || el.dataset.moduloStlInit === '1') return; // idempotent — editor re-renders
    el.dataset.moduloStlInit = '1';

    var dots   = Array.prototype.slice.call(el.querySelectorAll('[data-stl-dot]'));
    var slides = Array.prototype.slice.call(el.querySelectorAll('[data-stl-slide]'));
    var thumbs = Array.prototype.slice.call(el.querySelectorAll('[data-stl-thumb]'));
    var prev   = el.querySelector('[data-stl-prev]');
    var next   = el.querySelector('[data-stl-next]');
    var curEl  = el.querySelector('[data-stl-cur]');
    var count  = slides.length;
    if (count < 2) return;
    var cur = 0;

    function show(i) {
      cur = (i + count) % count;
      for (var s = 0; s < slides.length; s++) {
        var on = s === cur;
        slides[s].classList.toggle('is-active', on);
        if (on) slides[s].removeAttribute('aria-hidden'); else slides[s].setAttribute('aria-hidden', 'true');
      }
      for (var d = 0; d < dots.length; d++) {
        var dotOn = +dots[d].getAttribute('data-idx') === cur;
        dots[d].classList.toggle('is-active', dotOn);
        dots[d].setAttribute('aria-pressed', dotOn ? 'true' : 'false');
      }
      for (var t = 0; t < thumbs.length; t++) {
        var thOn = +thumbs[t].getAttribute('data-idx') === cur;
        thumbs[t].classList.toggle('is-active', thOn);
        thumbs[t].setAttribute('aria-selected', thOn ? 'true' : 'false');
      }
      if (curEl) curEl.textContent = pad2(cur + 1);
    }

    function bindIdx(nodes) {
      nodes.forEach(function (n) {
        n.addEventListener('click', function () { show(+n.getAttribute('data-idx')); });
      });
    }
    bindIdx(dots);
    bindIdx(thumbs);

    function onPrev() { show(cur - 1); }
    function onNext() { show(cur + 1); }
    if (prev) prev.addEventListener('click', onPrev);
    if (next) next.addEventListener('click', onNext);

    el.moduloStlTeardown = function () {
      if (prev) prev.removeEventListener('click', onPrev);
      if (next) next.removeEventListener('click', onNext);
      el.dataset.moduloStlInit = '';
    };

    show(0);
  }

  function initAll() {
    var els = document.querySelectorAll('[data-modulo-stl]');
    for (var i = 0; i < els.length; i++) initSection(els[i]);
  }

  function sectionTarget(e) {
    var t = e.target;
    if (!t || !t.querySelector) return null;
    if (t.matches && t.matches('[data-modulo-stl]')) return t;
    return t.querySelector('[data-modulo-stl]');
  }
  document.addEventListener('shopify:section:load', function (e) {
    var el = sectionTarget(e);
    if (el) initSection(el);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var el = sectionTarget(e);
    if (el && typeof el.moduloStlTeardown === 'function') el.moduloStlTeardown();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
